// import React from "react";
import React, { useState } from "react";

function ManageUserSetting() {
  // const navigate = useNavigate();
  const [checkAll, setCheckAll] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setCheckAll(isChecked);
    setCheckedItems(isChecked ? ["item1", "item2", "item3"] : []);
  };

  const handleCheckboxChange = (value) => {
    const updatedCheckedItems = checkedItems.includes(value)
      ? checkedItems.filter((item) => item !== value)
      : [...checkedItems, value];

    setCheckedItems(updatedCheckedItems);
    setCheckAll(updatedCheckedItems.length === 3);
  };
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Add User</h1>
          </div>
        </div>

        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={(e) => e.preventDefault()}
          >

            <span className="text-[#7B20C7] text-sm mb-2font-bold">
              <input
                id="checkAll"
                className="mr-3"
                type="checkbox"
                checked={checkAll}
                onChange={handleCheckAllChange}
              />
              Select All{" "}
            </span>
            <hr className="my-2 h-px border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-500 to-transparent opacity-25 dark:opacity-100" />

            <div className="flex">
              <div className=" grid grid-cols-6 ">
                <input
                  type="checkbox"
                  className=""
                  checked={checkedItems.includes("item2")}
                  onChange={() => handleCheckboxChange("item2")}
                  id="pe-"
                />
                Attendence
              </div>
              <div className=" grid-cols-12">
                <input
                  type="checkbox"
                  className="chk mr-3"
                  checked={checkedItems.includes("item2")}
                  onChange={() => handleCheckboxChange("item2")}
                  id="pe-5"
                />
                Bar
              </div>
            </div>
            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              // onClick={() => navigate(-1)}
              >
                Submit
              </button>

              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
              // onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default ManageUserSetting;
